import {getPlayRank, getPlayRankList, createPlayRank, updatePlayRank} from "api-v3";
import {convertMilliseconds, convertToTimeString} from "utils";
import TwoButtonPopup from "components/RedbrickEventContents/TwoButtonPopup";
import {showPopUp} from "components/PopUp";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import View from "./View";

export default function Container({isCloseUsable = false, singlePopup = false, dismiss}) {
  const {id, name} = useSelector(state => state.userinfo);
  const gameState = useSelector(state => state.game);
  const [myRank, setMyRank] = useState({});
  const [ranks, setRanks] = useState([]);

  useEffect(() => {
    if (gameState.messageFromGame?.record) {
      const updateRecord = async record => {
        try {
          getPlayRank({worldType: "JUMP"}).then(body => {
            if (body.code === 0) {
              let tag = "DEFAULT";
              createPlayRank({best: record, worldType: "JUMP", eventType: "DEFAULT", tag: tag}).then(() => {
                getMyRank();
                get30Ranks();
              });
            } else if (body.data.best === null || body.data.best > record) {
              updatePlayRank({worldType: "JUMP", eventType: "DEFAULT"}, {best: record}).then(() => {
                getMyRank();
                get30Ranks();
              });
            } else {
              getMyRank();
              get30Ranks();
            }
          });
        } catch (error) {
          console.log(error);
        }
      };

      updateRecord(gameState.messageFromGame.record);
    } else {
      getMyRank();
      get30Ranks();
    }
  }, []);

  const getMyRank = async () => {
    try {
      getPlayRank({worldType: "JUMP"}).then(body => {
        if (body.data) {
          body.data.best = convertRecord(body.data.best);
          setMyRank(body);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const get30Ranks = async () => {
    try {
      getPlayRankList({worldType: "JUMP"}).then(body => {
        body.data.items.forEach(user => {
          user.best = convertRecord(user.best);
        });
        setRanks(body.data.items);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const closeHandler = () => {
    if (gameState.messageFromGame?.record) {
      const time = convertRecord(gameState.messageFromGame.record);
      showPopUp(
        <TwoButtonPopup
          textSet={["Clear", `${time}`]}
          leftButtonText={"Ranking"}
          rightButtonText={"Special Stage"}
          leftHandler={{
            type: "ranking",
          }}
          rightHandler={{
            type: "redirect",
            url: "9e8129e8-b389-4872-8d8c-793434b8b521",
          }}
        />,
        {
          defaultPadding: false,
          transparentBackground: true,
          isOverlapPopup: true,
          clearOverHidden: true,
        },
      );
      dismiss();
    } else {
      dismiss();
    }
  };

  const convertRecord = record => {
    if (!record || record >= 3600000) return "-";
    const {minutes, seconds, milliseconds} = convertMilliseconds(record);
    return convertToTimeString([minutes, seconds, milliseconds]);
  };

  const getKSTDateString = () => {
    const date = new Date();

    date.setTime(date.getTime() + 9 * 60 * 60 * 1000);

    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const day = date.getUTCDate().toString().padStart(2, "0");
    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    const seconds = date.getUTCSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <View
      myRank={myRank}
      ranks={ranks}
      myId={id}
      isCloseUsable={isCloseUsable}
      singlePopup={singlePopup}
      name={name}
      closeHandler={closeHandler}
    />
  );
}
